import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { DELIVERY_POSTAL_CODE_PRICE_PATH } from '../../../../config/paths';
import Content from '../../../layout/Content';
import DeliveryPostalCodePriceForm from './DeliveryPostalCodePriceForm';
import {
  getDeliveryPostalCodeExcelTemplate,
  postDeliveryPostalCodePrice,
} from '../../../../actions/cargo/DeliveryPostalCodePrice';

const NewDeliveryPostalCodePrice = ({
  breadcrumbs,
  dispatchPostDeliveryPostalCodePrice,
  dispatchGetDeliveryPostalCodeExcelTemplate,
}) => {
  const onSubmit = (formValues) => {
    const newFormValues = {
      ...formValues,
      locationId: formValues.location ? formValues.location.value : null,
    };
    dispatchPostDeliveryPostalCodePrice(newFormValues);
  };

  const content = (
    <DeliveryPostalCodePriceForm
      onSubmit={onSubmit}
      dispatchGetTemplate={dispatchGetDeliveryPostalCodeExcelTemplate}
    />
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Tarifa de Reparto por Código Postal"
      subtitle="Crea una nueva tarifa de reparto por código postal"
      content={content}
    />
  );
};

NewDeliveryPostalCodePrice.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostDeliveryPostalCodePrice: PropTypes.func.isRequired,
  dispatchGetDeliveryPostalCodeExcelTemplate: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostDeliveryPostalCodePrice: postDeliveryPostalCodePrice,
  dispatchGetDeliveryPostalCodeExcelTemplate:
    getDeliveryPostalCodeExcelTemplate,
};

const mapStateToProps = ({ CargoUnit }) => ({
  breadcrumbs: [
    ...CargoUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tarifarios de Reparto por Código Postal',
      href: DELIVERY_POSTAL_CODE_PRICE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewDeliveryPostalCodePrice);
